// Use relative baseURL on localhost so CRA dev proxy can handle cross-origin requests
export const hostname = window.location.hostname.includes("localhost") ? "https://devapi.shivaydurga.com" : "https://api.shivaydurga.com/";
//export const hostname = "https://api.shivaydurga.com/";
export const MAP_API_KEY = "AIzaSyAvhjv8UL4uAJkAoh3CAF24ZEcg4huRbcg";